import React, { useEffect } from "react";
import { useUser } from "@/api/useUser";
import { useBot } from "@/api/useBot";
import { Modal } from "@/components/Modal";
import { MagicIcon } from "@/components/common/icons/MagicIcon";
import { BoldQuotedText } from "@/components/common/BoldQuotedText";
import { DotsLoader } from "@/components/common/Loader/DotsLoader";
import { useGrammarReview } from "@/api/useGrammarReview";

import styles from "./GrammarReviewModal.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  prevMessage: string;
};

export const GrammarReviewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  message,
  prevMessage,
}) => {
  const { data, grammarReview, isLoading, reset } = useGrammarReview();
  const { data: user, isLoading: isUserLoading } = useUser();
  const { data: bot } = useBot();

  useEffect(() => {
    if (!isOpen) {
      reset();
      return;
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (!user && !isUserLoading) {
      throw new Error("User is not logged in");
    }

    grammarReview({
      language: bot!.language,
      targetLanguage: user!.language,
      message: message,
      prevMessage: prevMessage,
    });
  }, [isOpen, user, isUserLoading]);

  return (
    <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <MagicIcon className={styles.magic} />
      <div className={styles.grammarTitle}>"{message}"</div>
      <div className={styles.grammarLabel}>Révision de grammaire</div>
      <div>
        {data && <BoldQuotedText className={styles.text} text={data} />}
      </div>
      {!data && isLoading && <DotsLoader className={styles.loader} />}
    </Modal>
  );
};
